import { render } from "./FishFrame.vue?vue&type=template&id=2e3ecca2&scoped=true"
import script from "./FishFrame.vue?vue&type=script&lang=js"
export * from "./FishFrame.vue?vue&type=script&lang=js"

import "./FishFrame.vue?vue&type=style&index=0&id=2e3ecca2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3ecca2"]])

export default __exports__